import { render, staticRenderFns } from "./IronMain.vue?vue&type=template&id=2f366f2d&scoped=true&"
import script from "./IronMain.vue?vue&type=script&lang=js&"
export * from "./IronMain.vue?vue&type=script&lang=js&"
import style0 from "./IronMain.vue?vue&type=style&index=0&id=2f366f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f366f2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f366f2d')) {
      api.createRecord('2f366f2d', component.options)
    } else {
      api.reload('2f366f2d', component.options)
    }
    module.hot.accept("./IronMain.vue?vue&type=template&id=2f366f2d&scoped=true&", function () {
      api.rerender('2f366f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/IronMain.vue"
export default component.exports